export default __webpack_public_path__ + "static/media/five-star.1ce2fa11.svg";